import { useLocation } from 'react-router';
import { sendEvent } from '@portal/services/firebase';
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import PendingDocuments from './PendingDocuments/PendingDocuments';
import { PageClass } from '@portal/enum/analytics';

const PendingDocumentsNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.ONBOARDING,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route path="/documentos-pendentes" exact>
        <PendingDocuments />
      </Route>
    </Switch>
  );
};

export default PendingDocumentsNavigation;
